import {HttpClient} from "@angular/common/http";
import {PathService} from "./path.service";
import {AuthenticationRequestModel} from "../../shared/models/authentication.request.model";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient,private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerSecurity}/auth`;
    }

    public login(authenticationRequestModel:AuthenticationRequestModel ){
        return this.http.post(`${this.baseUrl}` + '/login', authenticationRequestModel);
    }
}